module.exports = __webpack_public_path__ + "img/chivas-bottle.242130d4.png";